import { attr, fk } from 'redux-orm';

import BaseModel from './BaseModel';
import ActionTypes from '../constants/ActionTypes';

export default class extends BaseModel {
  static modelName = 'PointSystem';

  static fields = {
    id: attr(),
    isEnabled: attr({
      getDefault: () => true,
    }),
    boardId: fk({
      to: 'Board',
      as: 'board',
      relatedName: 'pointSystems',
    }),
  };

  static reducer({ type, payload }, PointSystem) {
    switch (type) {
      case ActionTypes.SOCKET_RECONNECT_HANDLE:
        PointSystem.all().delete();

        if (payload.pointSystems) {
          payload.pointSystems.forEach((pointSystem) => {
            PointSystem.upsert(pointSystem);
          });
        }

        break;
      case ActionTypes.CORE_INITIALIZE:
        if (payload.pointSystems) {
          payload.pointSystems.forEach((pointSystem) => {
            PointSystem.upsert(pointSystem);
          });
        }

        break;
      case ActionTypes.POINT_SYSTEM_UPDATE__SUCCESS:
        PointSystem.upsert(payload.pointSystem);

        break;
      default:
    }
  }
}

